var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('GalleryOverView', {
    attrs: {
      "isAllowedEdit": _vm.isAllowed('gallery_edit'),
      "isAllowedCSVDownload": _vm.isAvailable('gallery:csv_download')
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }